'use strict';

import currentLayout from '../../detect-layout';
import customModal from '../../modal';
import util from '../../util';
import recommendationCarousel from './recommendationsCarousel';

const currLayout = currentLayout.init();

/**
 * @function
 * @description Function to allow an event to fire after all images are loaded
 */
var imagesLoaded = function (element) {
	var $imgs = element.find('img[src!=""]');
	if (!$imgs.length) {return $.Deferred().resolve().promise();}

	var dfds = [];  
	$imgs.each(function(){
		var dfd = $.Deferred();
		dfds.push(dfd);
		var img = new Image();
		img.onload = function(){dfd.resolve();}
		img.onerror = function(){dfd.resolve();}
		img.src = this.src;
	});

	return $.when.apply($,dfds);
}

/**
* @description Homepage instgram modal handler
**/
var instaModal = function (element) {
	var instaModalBody,
		url = util.appendParamToURL($(element).attr('href'), 'format', 'ajax');

	$.ajax({
		url: url,
		dataType: 'html',
		success: function(response) {
			customModal.createCustomModal('insta-modal', '#modal-custom-placeholder');
			instaModalBody = $('.insta-modal .modal-body');
			instaModalBody.html(response);

			instaModalBody.html(response).imagesLoaded().then(function() {
				instaModalBody.scrollBox(); // apply scroll after all images are loaded successfully, It applies correct height to the scroll element.
			}).fail(function(){
				instaModalBody.scrollBox(); // apply scroll if any one of the images fails to load
			});
		}
	});
}

/**
 * @description Creates product recommendation carousel using Slick carousel
 **/
export default {
	init: function () {
		var $rvcarousel = $('.recently-viewed .carousel-recommendations').not('.slick-initialized');
		var $instacarousel = $('.js-insta .carousel-recommendations').not('.slick-initialized');
		var $socialMediaCarousel = $('.pdp-social-media-section .carousel-recommendations').not('.slick-initialized');
		var $slideCount = '01';

	if ($rvcarousel && $rvcarousel.length && $rvcarousel.children().length) {
		initializeSlick($rvcarousel, $slideCount, 5, 3);
	}
	if ($instacarousel && $instacarousel.length && $instacarousel.children().length) {
		initializeSlick($instacarousel, $slideCount, 4, 2);
	}
	if ($socialMediaCarousel && $socialMediaCarousel.length && $socialMediaCarousel.children().length) {
		initializeSlick($socialMediaCarousel, $slideCount, 1, 1);
	}

	$(document).on('click', '.insta-modal-anchor', function (e) {
		e.preventDefault();
		instaModal(this);
	});

	$.when('#recommendation').then(function () {
		recommendationCarousel.init();
	});
	
	}
}


if ($(".carousel-recommendations").length > 0 && $(".js-insta .carousel-recommendations").children('li').length > 0) {
	var count = $('.js-insta .carousel-recommendations>li').length;
	if (count >= 17) {
		$(".js-insta .carousel-recommendations").children('li').slice(16).detach();
	}
}

function initializeSlick($carousel, $slideCount, maxItems, minItems) {
	$carousel.on('init.slick', function (event, slick) {
		var $getSlickParentDiv = (slick.$dots) ? slick.$dots.parents('.rv-section') : slick.$slider.parents('.rv-section');
		var $carouselCounter = $getSlickParentDiv.find('.slick-counter');
		if ((currLayout == 'desktop' && slick.slideCount > maxItems) || (currLayout == 'mobile' && slick.slideCount > minItems)) {
			$carouselCounter.append('<span>' + $slideCount + '</span><span>' + (slick.$dots.children().length < 10 ? "0" : "") + slick.$dots.children().length + '</span>');
		}
		if ($carousel.hasClass('social-carousel')) {
			$('.social-carousel .slick-slide:not(".slick-active")').find('.social-slide').addClass('active-slide-animation');
		}
	});
	var slickSettings;
	if ($carousel.hasClass('insta-carousel')) {
		slickSettings = {
			infinite: false,
			easing: 'ease',
			dots: true,
			arrows: false,
			slidesToShow: maxItems,
			slidesToScroll: maxItems,
			rows: 1,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: minItems,
					slidesToScroll: minItems,
					rows: 2
				}
			}]
		}
	} else if ($carousel.hasClass('social-carousel')) {
		slickSettings = {
			infinite: false,
			easing: 'ease',
			dots: true,
			arrows: false,
			slidesToShow: maxItems,
			slidesToScroll: maxItems,
			slide: 'div',
			adaptiveHeight: true,
			speed: 400,
			waitForAnimate: true,
			responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: minItems,
					slidesToScroll: minItems
				}
			}]
		}
	} else {
		slickSettings = {
			infinite: false,
			easing: 'ease',
			dots: true,
			arrows: false,
			slidesToShow: maxItems,
			slidesToScroll: maxItems,
			slide: 'div',
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: minItems,
					slidesToScroll: minItems
				}
			}]
		}
	}
	$carousel.slick(slickSettings).on('afterChange', function (event, slick, currentSlide) {
		if (slick.$dots) {
			var $currSlideFrame = parseInt(slick.$dots.find('.slick-active').index());
			var $carouselCounter = slick.$dots.parents('.rv-section').find('.slick-counter');
			if (dragEle) {
				dragEle.setValue($currSlideFrame / (slick.$dots.children().length - 1))
			}
			$slideCount = $currSlideFrame + 1;
			if ((currLayout == 'desktop' && slick.slideCount > maxItems) || (currLayout == 'mobile' && slick.slideCount > minItems)) {
				$carouselCounter.html('<span>' + ($slideCount < 10 ? "0" : "") + $slideCount + '</span><span>' + (slick.$dots.children().length < 10 ? "0" : "") + slick.$dots.children().length + '</span>');
			}
		}
	});
	var $slick = $carousel.slick("getSlick");
	if ((currLayout == 'desktop' && $slick.slideCount > maxItems) || (currLayout == 'mobile' && $slick.slideCount > minItems)) {
		var slideCounts = $slick.$dots.children().length;
		var $dragdealer = $slick.$slider.parent('.rv-section').find('.dragdealer .handle');
		$dragdealer.width((100 / slideCounts) + '%');
		var $dragInstance;
		if ($carousel.hasClass('insta-carousel')) {
			$dragInstance = 'insta-dragable-slider';
		} else if ($carousel.hasClass('social-carousel')) {
			$dragInstance = 'social-dragable-slider';
			var pevX = 0;
		} else {
			$dragInstance = 'dragable-slider';
		}

		var dragEle = new Dragdealer($dragInstance, {
			disabled: false,
			steps: slideCounts,
			speed: 0.5,
			requestAnimationFrame: true,
			callback: function (x, y) {
				currLayout = currentLayout.init();
				var slickTiggerItems = $slick.$dots.children();
				var x = x * (slickTiggerItems.length - 1);
				if (currLayout == 'desktop' && $carousel.hasClass('social-carousel') && !(x === pevX)) {
					$('.social-carousel .slick-slide').eq(pevX).find('.social-slide').addClass('active-slide-animation');
					setTimeout(function () {
						if (!(slickTiggerItems.eq(x).hasClass('slick-active'))) {
							slickTiggerItems.eq(x).trigger('click');
						}
					}, 300);
					setTimeout(function () {
						$('.social-carousel .slick-slide').eq(x).find('.social-slide').removeClass('active-slide-animation');
					}, 600);
					pevX = x;
				} else {
					if (!(slickTiggerItems.eq(x).hasClass('slick-active'))) {
						slickTiggerItems.eq(x).trigger('click');
					}
				}
			}
		});
	} else {
		$slick.$slider.parent('.rv-section').find('.dragdealer').hide();
	}

}



function checkWhishlistProduct(wishlistProd) {
	$(".wishlist-icon").each(function () {
		var _this = $(this);
		var currEle = _this.attr('data-element-pid');
		_this.removeClass("wishlist-added");
		if (wishlistProd != null && wishlistProd.indexOf(currEle) >= 0) {
			_this.addClass("wishlist-added");
		}
	});
}

// Initialize
$(window).on("load", function() {
	setTimeout(function() {		
		checkWhishlistProduct(window.User.wishlistProducts);		
	}, 5000);
});